<template>
  <div>
    <!-- Loading -->
    <!--    <loading :active.sync="isLoading" :is-full-page="true"></loading>-->
    <BannerCarousel :slides="banner" :lang="lang" />

    <v-container id="events-list">
      <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
      <v-layout justify-space-between class="pb-4" :column="$vuetify.breakpoint.xs">
        <v-flex shrink>
          <div class="d-flex flex-1 align-end">
            <span class="text-uppercase header bold text-tcdc-green">program</span>
          </div>
        </v-flex>
        <v-flex shrink :class="{ 'my-3': $vuetify.breakpoint.xs }">
          <div class="d-flex align-center" style="position: relative" v-if="tagName !== 'mini-tcdc'"
            :class="{ 'justify-end': $vuetify.breakpoint.mdAndUp }">
            <!-- <GreenButton :label="$t('event.ourService')" @click.native="$router.push(`/${lang}` + '/our-service')" /> -->
            <v-tooltip bottom color="rgba(0,0,0,0)" v-if="$vuetify.breakpoint.smAndUp">
              <template v-slot:activator="{ on }">
                <img v-on="on" alt="tcdc-event" class="sort-icon pl-4 pb-1 cursor-pointer"
                  src="../../assets/icons/sorts/design-world.png" @click="designCalendarHandler" />
              </template>
              <span class="text-tcdc-green bold sub-header1 text-uppercase">design world calendar</span>
            </v-tooltip>
            <div v-else class="text-tcdc-green text-uppercase d-flex align-center">
              <img alt="tcdc-event" class="sort-icon-mobile pl-4 mr-2 cursor-pointer"
                src="../../assets/icons/sorts/design-world.png" @click="designCalendarHandler" />
              <span style="font-size: 14px; font-weight: bold">design world calendar</span>
            </div>
          </div>
        </v-flex>
      </v-layout>
      <v-layout justify-center mb-3>
        <v-flex :shrink="$vuetify.breakpoint.smAndUp">
          <div v-if="$vuetify.breakpoint.mdAndUp" class="d-flex flex-1 align-center" style="position: relative;"
            :class="{ 'justify-center': $vuetify.breakpoint.mdAndUp }">
            <span class="text-uppercase text-tcdc-green bold pr-2">{{ $t('event.sortBy') + ':' }}</span>
            <template v-for="item of sortByList">
              <div :key="item.id.toString()" class="d-relative">
                <v-tooltip bottom color="rgba(0,0,0,0)">
                  <template v-slot:activator="{ on }">
                    <img v-on="on" alt="event-sorter" class="tcdc-sort-icon-hover sort-icon px-2 cursor-pointer"
                      :src="eventSortType === item.name ? item.image_active : item.image_inactive"
                      @click="sortClick(item)" />
                    <!--                    :src="events[0].event_type === item.name ? item.image_active:item.image_inactive"-->
                  </template>
                  <span class="text-tcdc-green bold sub-header1 text-uppercase">{{ item.name }}</span>
                </v-tooltip>
              </div>
            </template>
          </div>
          <v-select v-else class="tcdc-sort-by-dropdown text-uppercase" style="color: white;" solo rounded color="white"
            item-color="#2e8037" background-color="#2e8037" :items="sortByList" item-text="name" item-value="name"
            :label="$t('event.sortBy') + ':'" v-model="eventSortType" hide-details @change="sortChange"></v-select>
        </v-flex>
      </v-layout>
      <div v-if="eventSortType === 'date'">
        <div class="d-flex flex-1 py-2 borderbot justify-space-between">
          <div class="d-flex align-center justify-start">
            <template v-if="!showCalendar">
              <label class="d-flex" for="selectedDate">
                <v-icon large color="#808080">mdi-magnify</v-icon>
              </label>
              <div class="ml-2">
                <span style="font-family: 'Poppins', 'Kanit', sans-serif; font-size: 19px; color: #999"
                  class="cursor-pointer" @click="openCalender">
                  {{ $t('event.selectDate') }}
                </span>
              </div>
              <!--              <template v-if="showCalendar">-->
              <!--                <DatePicker-->
              <!--                    id="selectedDateSearch"-->
              <!--                    @onPress="yearMonthHandler"-->
              <!--                    :value="selectedDate"-->
              <!--                    class="flex-shrink-1"-->
              <!--                />-->
              <!--              </template>-->

            </template>
            <template v-else>
              <label class="d-flex pt-2" for="selectedDate">
                <v-icon large color="#808080" class="mr-2">mdi-magnify</v-icon>
              </label>

              <DatePicker id="selectedDate" @onPress="yearMonthHandler" :value="selectedDate" class="flex-shrink-1" />

            </template>
            <v-icon v-if="has_search == true" large color="white" @click="clearSearch" class="mx-3"
              style="background-color: #999999;border-radius: 30px;font-size: 18px">mdi-close</v-icon>
          </div>
          <div class="d-flex align-center" style="font-family: 'Poppins', 'Kanit', sans-serif;">
            <span class="sub-header1 bold text-tcdc-grey1 color-grey1 cursor-pointer mx-1" @click="prevYear2Handler">
              <v-icon large color="#808080" class="  ">mdi-chevron-left</v-icon>
              <!-- {{ prevYearOne }} -->
            </span>

            {{ current_year }}

            <span v-if="untilNextYear" class="sub-header1 bold text-tcdc-grey1 color-grey1 cursor-pointer mx-1"
              @click="prevYear1Handler">
              <!-- {{ prevYearTwo }} -->
              <v-icon large color="#808080" class="">mdi-chevron-right</v-icon>
            </span>
            <span v-else class="sub-header1 bold text-tcdc-grey1 color-white mx-1">
              <v-icon large color="#FFFFFF">mdi-chevron-right</v-icon>
            </span>
          </div>
        </div>
      </div>
      <v-row class="d-flex flex-wrap mt-2" v-if="events && events.length > 0">
        <template v-for="(item, index) in returnEvents">
          <!-- <v-col cols="12" :md="(item.highlight || item.highlightHero) ? 12 : 6" :key="index"> -->
          <!-- <v-col cols="12" :md="(item.highlightHero) ? 12 : (item.highlight) ? 12 : 6" :key="index"> -->

          <!-- <v-col cols="12" :md="(item.highlightHero) ? 12 : 6" :key="index">
            <EventCard class="cursor-pointer" :name="item[`name_${lang}`]"
              :time_start="item[`start_date_${lang}`] | moment('DD MMM YYYY')"
              :time_end="item[`end_date_${lang}`] | moment('DD MMM YYYY')" :place="item[`place_${lang}`]"
              :img="item.img_cover && item.img_cover.mobile ? ($vuetify.breakpoint.smAndDown ? item.img_cover.mobile : item.img_cover.desktop) : item.img_cover"
              :id="index" :href-link="eventDetailHandler(item.id)" :event_date="item[`eventDate_${lang}`]" />
          </v-col> -->

          <v-col cols="12"
            :md="(item.highlightHero) ? 12 : (item.highlight && highlight_Hero) ? 6 : (item.highlight && !highlight_Hero) ? 12 : 6"
            :key="index">
            <EventCard class="cursor-pointer" :name="item[`name_${lang}`]"
              :time_start="item[`start_date_${lang}`] | moment('DD MMM YYYY')"
              :time_end="item[`end_date_${lang}`] | moment('DD MMM YYYY')" :place="item[`place_${lang}`]"
              :img="item.img_cover && item.img_cover.mobile ? ($vuetify.breakpoint.smAndDown ? item.img_cover.mobile : item.img_cover.desktop) : item.img_cover"
              :id="index" :href-link="eventDetailHandler(item.id)" :event_date="item[`eventDate_${lang}`]" />
          </v-col>

        </template>
      </v-row>
      <v-row v-else class="grey--text mt-3 px-2">
        <v-col style="text-align: center">
          {{ $t('event.itemNotFound') }} {{ branchName }}
        </v-col>
      </v-row>
      <v-row class="pt-4 d-flex justify-end">
        <!--        <v-col class="text-left">-->
        <!--          <GreenButton label="previous" v-if="eventPage.current_page !== 1" @onPress="prevPage()" />-->
        <!--        </v-col>-->
        <!--        <v-col class="text-right">-->
        <!--          <GreenButton label="next" v-if="eventPage.current_page !== eventPage.last_page" @onPress="nextPage()" />-->
        <!--        </v-col>-->
        <v-pagination v-if="eventPage" v-model="eventPage.current_page" :length="eventPage.last_page" total-visible="7"
          prev-icon="mdi-menu-left" next-icon="mdi-menu-right" color="#2e8037"
          @input="(event) => { getEventData(event); $vuetify.goTo('#events-list'); }"></v-pagination>
      </v-row>
      <v-row class="pt-7 pb-3">
        <v-col>
          <span class="text-uppercase text-tcdc-green sub-header1 bold">{{ $t('event.service') }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <ServiceExpandable />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import EventCard from "../../components/cards/EventCard";
// import GreenButton from "../../components/buttons/GreenButton";
import ServiceExpandable from "../../components/expandables/ServiceExpandable";
// import GreenLabel from "../../components/labels/GreenLabel";
import BannerCarousel from "../../components/carousels/BannerCarousel";
import { mapState } from "vuex";
import _move from 'lodash-move';
// import Loading from 'vue-loading-overlay';
import moment from "moment";
import DatePicker from "../../components/pickers/DatePicker";
import { BreadcrumbUtil } from "@/util/BreadcrumbUtil";
import { Utils } from "@/util/Utils";

export default {
  components: {
    EventCard,
    // GreenButton,
    ServiceExpandable,
    // GreenLabel
    BannerCarousel,
    DatePicker,
    // Loading
  },
  created() {
    this.items = BreadcrumbUtil.setServiceItem(
      this.items,
      this.branchId,
      this.branchName,
      this.allBranches,
      this.lang
    )
    const date = new Date();
    const currentMonth = parseInt(date.getMonth()) + 1;
    // const currentYear = date.getFullYear() - 7;
    const currentYear = date.getFullYear();
    this.prevYear1 = currentYear + 1;
    this.prevYear2 = currentYear - 1;
    this.current_year = currentYear + 543
    this.year_next = (currentYear + 543)
    this.selectedDate = `${currentYear} ${this.monthList[currentMonth]}`;

    this.date = `${currentYear}-${moment().month(this.monthList[currentMonth]).format('MM')}`;
    // this.$store.dispatch('Program/onGetDesignWorldCalendar', { date: param, lang: this.lang });
    this.getEventData();
  },
  computed: {
    ...mapState({
      events: state => {
        if (state.Program.programs) {

          // state.Program.programs.data.push({
          //   is_highlight_hero: false,
          //   is_highlight: 0,
          //   name_th: "Future Tapped : Creative vision through Communication Design 'Calligraphy'",
          //   name_en: "Future Tapped : Creative vision through Communication Design 'Calligraphy'",
          //   start_date_en: "7 November 2023",
          //   start_date_th: "2 พ.ค. 2566",
          //   end_date_en: "3 December 2023",
          //   end_date_th: "3 ธ.ค. 2566",
          //   location_name_th: 'TCDC กรุงเทพฯ',
          //   location_name_en: 'TCDC Bangkok',
          //   img_cover_desktop: "https://cdn.zipeventapp.com/images/events/494A7895-F7CA-4A6A-8C79-168500043D1E/710AA412-DA73-40BF-940F-CC770F28A991.jpg",
          //   img_cover_mobile: "https://cdn.zipeventapp.com/images/events/494A7895-F7CA-4A6A-8C79-168500043D1E/E35AEBC5-A7C7-4DD0-9EF0-806DEFF53C7A.jpg",
          //   img_cover: {
          //     desktop: "https://event.tcdc.or.th/1699265328-19967750.PNG",
          //     mobile: "https://event.tcdc.or.th/1699265328-99333448.png"
          //   },
          //   events_date: "4-6 Dec 2023,3-17 Jan 2024 4-6 Dec 2023,3-17 Jan 2024 4-6 Dec 2023,3-17 Jan 2024 4-6 Dec 2023,3-17 Jan 2024 4-6 Dec 2023,3-17 Jan 2024 4-6 Dec 2023,3-17 Jan 2024",
          //   // events_date: "4-6 Dec 2023,3-17 Jan 20244-6 Dec 2023,3-17 Jan 20244-6 Dec 2023,3-17 Jan 20244-6 Dec 2023,3-17 Jan 20244-6 Dec 2023,3-17 Jan 20244-6 Dec 2023,3-17 Jan 2024",
          //   events_date_th: "4-6 ธ.ค 2566,3-17 ม.ค 2567",
          //   product_id: 918,
          //   source: "3,4,5,6,7,8"
          // },
          //   {
          //     is_highlight_hero: false,
          //     is_highlight: 0,
          //     name_th: "Future Tapped : Creative vision through Communication Design 'Calligraphy'2",
          //     name_en: "Future Tapped : Creative vision through Communication Design 'Calligraphy'2",
          //     start_date_en: "7 November 2023",
          //     start_date_th: "2 พ.ค. 2566",
          //     end_date_en: "3 December 2023",
          //     end_date_th: "3 ธ.ค. 2566",
          //     location_name_th: 'TCDC กรุงเทพฯ',
          //     location_name_en: 'TCDC Bangkok',
          //     img_cover_desktop: "https://cdn.zipeventapp.com/images/events/C246AA80-00EF-46DD-9CCD-60841792BDBD/19CFD6D4-74C3-4566-9527-CACF75FE90C7.jpg",
          //     img_cover_mobile: "https://cdn.zipeventapp.com/images/events/494A7895-F7CA-4A6A-8C79-168500043D1E/E35AEBC5-A7C7-4DD0-9EF0-806DEFF53C7A.jpg",
          //     img_cover: {
          //       desktop: "https://event.tcdc.or.th/1699265328-19967750.PNG",
          //       mobile: "https://event.tcdc.or.th/1699265328-99333448.png"
          //     },
          //     events_date: "4-6 Dec 2023,3-17 Jan 2024 4-6 Dec 2023,3-17 Jan 2024 4-6 Dec 2023,3-17 Jan 2024 4-6 Dec 2023,3-17 Jan 2024 4-6 Dec 2023,3-17 Jan 2024 4-6 Dec 2023,3-17 Jan 2024",
          //     // events_date: "4-6 Dec 2023,3-17 Jan 20244-6 Dec 2023,3-17 Jan 20244-6 Dec 2023,3-17 Jan 20244-6 Dec 2023,3-17 Jan 20244-6 Dec 2023,3-17 Jan 20244-6 Dec 2023,3-17 Jan 2024",
          //     events_date_th: "4-6 ธ.ค 2566,3-17 ม.ค 2567",
          //     product_id: 918,
          //     source: "3,4,5,6,7,8"
          //   }
          // )

          // console.log(state.Program.programs.data)
          return Object.values(state.Program.programs.data).map((event, index) => ({
            index: index,
            id: event.product_id,
            name_th: event.name_th,
            name_en: event.name_en,
            start_date_th: event.start_date_th,
            start_date_en: event.start_date_en,
            end_date_th: event.end_date_th,
            end_date_en: event.end_date_en,
            place_th: event.location_name_th,
            place_en: event.location_name_en,
            img_cover: event.img_cover_desktop && event.img_cover_mobile ? { mobile: event.img_cover_mobile, desktop: event.img_cover_desktop } : event.img_cover_desktop,
            highlight: event.is_highlight == 1,
            highlightHero: event.is_highlight_hero == 1,
            eventDate_en: event.events_date,
            eventDate_th: event.events_date_th,
            source: event.source,
          }));
        }
        return []
      },
      eventPage: state => state.Program.programs,
      branchName: state => state.Branch.branch_name,
      allBranches: state => state.Branch.branches,
      branchId: state => state.Branch.branch_id,
      tagName: state => state.Branch.tag_name,
      lang: state => state.Branch.lang,
      banner: state => state.ServiceMenu.banner
    }),
    branchChanged: function () {

      return this.branchName;
    },
    prevYearOne: function () {
      if (this.lang === 'th') {
        return parseInt(this.prevYear1) + 543;
      } else {
        return this.prevYear1;
      }
    },
    prevYearTwo: function () {
      if (this.lang === 'th') {
        return parseInt(this.prevYear2) + 543;
      } else {
        return this.prevYear2;
      }
    },
    currentYear: function () {
      if (this.lang === 'th') {
        return parseInt(this.current_year) + 543;
      } else {
        return this.current_year;
      }
    },
    untilNextYear: function () {
      if ((this.current_year - 543) != new Date().getFullYear()) {
        return true
      }
      for (const x of this.events) {
        // get end date year
        if (x.end_date_en && x.end_date_en.split(' ')[2] > (this.current_year - 543)) {
          return true
        }
      }
      return false
    },

    returnEvents: function () {
      let highlight = this.findHighlight()
      let highlightHero = this.findHighlightHero()

      if (highlightHero !== 0) {
        let ev = this.events
        ev = this.move(ev, ev.findIndex((event => (event.highlightHero))), 0)
        return ev
      } else {
        if (highlight !== 0) {
          let ev = this.events
          ev = this.move(ev, ev.findIndex((event => (event.highlight))), 0)
          if (highlight > 1) {
            ev = this.move(ev, ev.findIndex(((event, i) => {
              if (i !== 0) {
                return event.highlight
              }
            })), 5)
          }
          return ev
        }
      }
      return this.events
    }

    // returnEvents: function () {
    //   let highlight = this.findHighlight()
    //   if (highlight !== 0) {
    //     let ev = this.events
    //     ev = this.move(ev, ev.findIndex((event => (event.highlight || event.highlightHero))), 0)
    //     if (highlight > 1) {
    //       ev = this.move(ev, ev.findIndex(((event, i) => {
    //         if (i !== 0) {
    //           return event.highlight || event.highlightHero
    //         }
    //       })), 5)
    //     }
    //     return ev
    //   }
    //   return this.events
    // }

    // returnEvents: function () {
    //   let highlight = this.findHighlight()
    //   let highlightHero = this.findHighlightHero()
    //   if (highlight !== 0) {
    //     let ev = this.events
    //     ev = this.move(ev, ev.findIndex((event => (event.highlight || event.highlightHero))), 0)
    //     // ev = this.move(ev, ev.findIndex((event => (event.highlightHero))), 0)
    //     if (highlight > 1) {
    //       ev = this.move(ev, ev.findIndex(((event, i) => {
    //         console.log("i= " + i);
    //         if (i !== 0) {
    //           return event.highlight || event.highlightHero
    //           // return event.highlightHero
    //         }
    //       })), 5)
    //     }
    //     return ev
    //   }
    //   return this.events
    // }

    // returnEvents: function () {
    //   let highlight = this.findHighlight()
    //   let highlightHero = this.findHighlightHero()

    //   if (highlightHero !== 0) {
    //     let ev = this.events
    //     ev = this.move(ev, ev.findIndex((event => (event.highlightHero))), 0)
    //     return ev
    //   } else {
    //     let ev = this.events
    //     const highlightedEvents = ev.filter(event => event.highlight);

    //     for (let i = 0; i < highlightedEvents.length; i++) {
    //       ev = this.move(ev, ev.indexOf(highlightedEvents[i]), i);
    //     }
    //     return ev
    //   }
    // }
  },
  watch: {
    branchChanged: function () {
      this.has_search = false;
      this.items = BreadcrumbUtil.setServiceItem(
        this.items,
        this.branchId,
        this.branchName,
        this.allBranches,
        this.lang,
      )
      this.getEventData();
    }
  },
  methods: {
    openCalender() {
      // let temp =  document.getElementById('selectedDateSearch')
      // temp.style.display='block';
      this.showCalendar = true;
      this.has_search = true;
      // return this.showCalendar;
    },
    eventDetailHandler(id) {
      const branch = Utils.getBranchNameById(this.branchId, this.allBranches);
      return `/${this.lang}` + `${branch}/events/${id}`
    },
    // findHighlight() {
    //   let found = 0;
    //   for (const e of this.events) {
    //     // if (e.highlightHero) found++;
    //     if (e.highlight || e.highlightHero) found++;
    //     if (e.highlightHero) this.highlight_Hero = true;
    //   }
    //   return found;
    // },
    findHighlight() {
      let found = 0;
      for (const e of this.events) {
        if (e.highlight) found++;
      }
      return found;
    },
    findHighlightHero() {
      let found = 0;
      for (const e of this.events) {
        if (e.highlightHero) {
          found++;
          this.highlight_Hero = true;
        }
      }
      return found;
    },
    designCalendarHandler() {
      const branch = Utils.getBranchNameById(this.branchId, this.allBranches);
      this.$router.push(`/${this.lang}` + `${branch}/service/resource-center/design-world-calendar`);
    },
    async getEventData(page) {
      this.isLoading = true;
      const date = new Date()

      console.log(date);
      // this.has_search = false;
      this.current_year = date.getFullYear() + 543;
      const currentMonth = parseInt(date.getMonth()) + 1;
      // this.selectedDate = `${date.getFullYear()} ${this.monthList[currentMonth]}`;
      page = page ? page : 1;
      this.isLoading = true;
      await this.$store.dispatch("Program/getProgramEventAll", {
        tag: this.tagName,
        lang: this.lang,
        page: page,
        sort: this.eventSortType,
        eventdate: this.date
      });
      this.isLoading = false;
      return true;
    },
    async changePage(page) {
      let hasSearch
      if (this.has_search) hasSearch = true
      await this.$store.dispatch('Program/getProgramByPage', {
        tag: this.tagName,
        page: page,
        sort: this.eventSortType
      });
      if (hasSearch) this.has_search = true
    },
    async sortClick(type) {
      this.eventSortType = type.name;
      this.isLoading = true;
      switch (type.name) {
        case 'exhibition':
        case 'workshop':
        case 'event':
          await this.$store.dispatch('Program/getProgramEventAll', { tag: this.tagName, lang: this.lang, sort: type.name });
          this.isLoading = false;
          break;

        case 'date':
          this.date = this.selectedDate.split(' ')[0] + '-' + moment().month(this.selectedDate.split(' ')[1]).format('MM');
          await this.$store.dispatch('Program/getProgramEventAll', {
            tag: this.tagName,
            lang: this.lang,
            sort: 'date',
            eventdate: this.date
          });
          this.isLoading = false;
          break;
        default:
          this.isLoading = false;
      }
    },
    sortChange(type) {
      this.isLoading = true;
      switch (type) {
        case 'exhibition':
        case 'workshop':
        case 'event':
          // this.searchBox = false;
          this.$store.dispatch('Program/getProgramEventAll', { tag: this.tagName, lang: this.lang, sort: type });
          this.isLoading = false;
          break;
        case 'date':
          this.date = this.selectedDate.split(' ')[0] + '-' + moment().month(this.selectedDate.split(' ')[1]).format('MM');
          this.$store.dispatch('Program/getProgramEventAll', {
            tag: this.tagName,
            lang: this.lang,
            sort: 'date',
            eventdate: this.date
          });
          this.isLoading = false;
          break;
      }
    },
    yearMonthHandler(yearMonth) {
      this.isLoading = true;
      const arr = yearMonth.split("-");
      const year = parseInt(arr[0]);
      const month = parseInt(arr[1]);
      this.current_year = year
      this.prevYear1 = year + 1;
      this.prevYear2 = year - 1;
      this.current_year = year + 543
      this.has_search = true;
      this.selectedDate = `${year} ${this.monthList[month]}`;
      this.date = `${year}-${moment().month(this.monthList[month]).format('MM')}`;
      this.$store.dispatch('Program/getProgramEventAll', {
        tag: this.tagName,
        lang: this.lang,
        sort: 'date',
        eventdate: this.date
      });
      this.isLoading = false;
    },
    prevYear1Handler() {
      this.isLoading = true;
      const arr = this.selectedDate.split(" ");
      const year = parseInt(this.prevYear1);
      const month = arr[1];
      this.prevYear1 = year + 1;
      this.prevYear2 = year - 1;
      this.current_year = year + 543
      // this.has_search = true;
      this.selectedDate = `${year} ${month}`;
      this.date = `${year}-${moment().month(month).format('MM')}`;
      this.$store.dispatch('Program/getProgramEventAll', {
        tag: this.tagName,
        lang: this.lang,
        sort: 'date',
        eventdate: this.date
      });
      this.isLoading = false;
    },
    prevYear2Handler() {
      this.isLoading = true;
      const arr = this.selectedDate.split(" ");
      const year = parseInt(this.prevYear2);
      const month = arr[1];
      this.prevYear1 = year + 1;
      this.prevYear2 = year - 1;
      this.current_year = year + 543
      // this.has_search = true;
      this.selectedDate = `${year} ${month}`;
      this.date = `${year}-${moment().month(month).format('MM')}`;
      this.$store.dispatch('Program/getProgramEventAll', {
        tag: this.tagName,
        lang: this.lang,
        sort: 'date',
        eventdate: this.date
      });
      this.isLoading = false;
    },
    clearSearch() {
      this.has_search = false;
      this.showCalendar = false;
      window.location.reload();
    }
  },
  data: () => ({
    highlight_Hero: false,
    active: false,
    showCalendar: false,
    has_search: false,
    current_year: '',
    eventSortType: 'date',
    isLoading: false,
    move: _move,
    year_next: "",
    selectedDate: "",
    prevYear1: "",
    prevYear2: "",
    sortByList: [
      {
        id: 1,
        name: "date",
        image_active: require("../../assets/icons/sorts/calendar.png"),
        image_inactive: require("../../assets/icons/sorts/calendar-inactive.png")
      },
      {
        id: 2,
        name: "exhibition",
        image_active: require("../../assets/icons/sorts/exhibition.png"),
        image_inactive: require("../../assets/icons/sorts/exhibition-inactive.png")
      },
      {
        id: 3,
        name: "workshop",
        image_active: require("../../assets/icons/sorts/workshop.png"),
        image_inactive: require("../../assets/icons/sorts/workshop-inactive.png")
      },
      {
        id: 4,
        name: "event",
        image_active: require("../../assets/icons/sorts/seminar.png"),
        image_inactive: require("../../assets/icons/sorts/seminar-inactive.png")
      }
    ],
    items: [
      {
        text: 'TCDC BANGKOK',
        to: "/home/tcdc-bangkok"
      },
      {
        text: "PROGRAM",
        to: "/home"
      }
    ],
    serviceList: [
      {
        id: "1",
        title: "membership",
        layout: "1"
      },
      {
        id: "2",
        title: "resource center",
        layout: "2"
      },
      {
        id: "3",
        title: "consult",
        layout: "3"
      },
      {
        id: "4",
        title: "space rentals",
        layout: "4"
      },
      {
        id: "5",
        title: "visit & service area",
        layout: "5"
      }
    ],
    date: null,
    monthList: [
      "",
      "JANUARY",
      "FEBUARY",
      "MARCH",
      "APRIL",
      "MAY",
      "JUNE",
      "JULY",
      "AUGUST",
      "SEPTEMBER",
      "OCTOBER",
      "NOVEMBER",
      "DECEMBER"
    ]
  })
};
</script>

<style lang="scss">
span.d-flex.flex-1.align-center.sub-header1.bold.text-tcdc-grey1.color-grey1 {
  text-align: center;
  padding-left: 10px !important;
  padding-right: 10px !important;
  color: white !important;
  background-color: #2e8037;
  border: #2e8037 2px solid !important;
  border-radius: 30px !important;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);

}

.sort-icon {
  height: 40px;
  width: 58px;
  object-fit: contain;
}

.sort-icon-mobile {
  height: 32px;
  object-fit: contain;
}

.search-icon {
  height: 40px;
  width: 40px;
  object-fit: contain;
}

.search-box {
  border: solid 2px $tcdcGreen;
  background: #fff;
  min-width: 280px;
}

.borderbot {
  border-bottom: 2px solid $tcdcGrey1;
}

/* .tcdc-sort-icon-hover:hover + .tcdc-sort-tooltip {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
} */
/* .tcdc-sort-tooltip {
  display: none;
} */
</style>
